export class ApiService {
    locale: string;

    constructor(locale: string) {
        this.locale = locale;
    }

    async fetch<T>(url: string, options?: RequestInit): Promise<T> {
        try {
            const response = await fetch(url, {
                ...options,
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': this.locale,
                    'X-XSRF-TOKEN': this.getCookie('XSRF-TOKEN') || '',
                    ...options?.headers
                }
            });

            if (!response.ok) {
                const errorData = await response.json();

                throw {
                    message: errorData?.message || 'An error occurred',
                    status: response.status
                };
            }

            return await response.json();
        } catch (error: any) {
            console.error('API call failed:', error);
            throw error;
        }
    }

    private getCookie(name: string): string | null {
        if (!document.cookie) {
            return null;
        }

        const cookies = document.cookie.split(';')
            .map(c => c.trim())
            .filter(c => c.startsWith(name + '='));

        if (cookies.length === 0) {
            return null;
        }
        return decodeURIComponent(cookies[0].split('=')[1]);
    }
}
